import { useState } from "react";
import DataFrame from "../../components/DataFrame/DataFrame";
import { apiClient } from "../../api/api-client";
import { useNavigate } from "react-router";
import Logo from "../../components/Logo";
import Input from "heroic-ui-library/dist/components/Input";
import Button from "heroic-ui-library/dist/components/Button";
import Loading from "react-loading";
import Cookies from "js-cookie";

function Email() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const nav = useNavigate();

  const parent_code_cookie = Cookies.get("parent_code");
  const parent_code =
    parent_code_cookie != undefined ? parent_code_cookie + "" : "";
  const gotoParentPage = () => {
    nav(`${"/parent_code/" + parent_code}`);
  };

  if (parent_code === "") {
    nav("/connect");
    return;
  }

  const sendEmail = async () => {
    setIsLoading(true);

    const response = await apiClient.sendEmail(email, parent_code);

    if (response.code == 200) {
      alert("Succeed");
    } else if (response.code == 400) {
      setError(response.msg);
    }

    setIsLoading(false);
  };

  return (
    <div className="flex flex-col h-full justify-center items-center">
      <div className="absolute left-6 top-6">
        <Logo />
      </div>
      <DataFrame>
        <div className="w-full h-full flex flex-col space-y-2 items-center justify-center py-3 px-3">
          {/* <h1 className="text-4xl font-acme">Hello {auth.user_name}</h1> */}
          <p className="font-acme text-2xl w-96 mb-2">
            Please enter your email address
          </p>
          <Input
            value={email}
            onChange={(e) => {
              setEmail(e.currentTarget.value);
              setError("");
            }}
            placeholder="Your Email address"
          />
          {error && (
            <div className="font-acme text-red-700 text-2xl capitalize">
              {error}
            </div>
          )}

          {!isLoading ? (
            <Button
              className="!mt-8 !text-4xl btn"
              onClick={sendEmail}
              btnType="green"
              label="Submit"
            />
          ) : (
            <Loading type="spin" color="#002356" />
          )}

          <Button
            className="!mt-8 !text-4xl btn"
            btnType="green"
            label="Goto parent page"
            onClick={gotoParentPage}
          />
        </div>
      </DataFrame>
    </div>
  );
}

export default Email;
